<div
	class="menu-lateral"
	[ngClass]="{
		expanded: menuLateralService.isMenuExpanded(),
		hoverOpen: viewMode() === 'hoverOpen',
		alwaysOpen: viewMode() === 'alwaysOpen',
		alwaysClosed: viewMode() === 'alwaysClosed',
		hamburgerOpen: viewMode() === 'hamburgerOpen',
	}"
	id="menuLateral">
	<div class="route-menu" (mouseenter)="expandMenu()" (mouseleave)="collapseMenu()">
		@for (menuItem of menuArray; track $index) {
			@if (menuItem.onClick === undefined && menuItem.children?.length === 0) {
				<a
					class="menu-item"
					[routerLink]="menuItem.routerLink"
					[routerLinkActive]="'active'"
					(click)="
						viewMode() === 'hamburgerOpen' && menuItem.children?.length === 0
							? menuLateralService.isMenuExpanded.set(false)
							: null
					">
					<fa-icon [icon]="menuItem.icon"></fa-icon>
					@if (isExpanded()) {
						<span>{{ labels[menuItem.name] ? labels[menuItem.name] : menuItem.name }}</span>
					}
				</a>
			} @else {
				<div class="menu-item" (click)="expandMenuItem(menuItem); menuItem.onClick && menuItem.onClick()">
					<fa-icon [icon]="menuItem.icon"></fa-icon>
					@if (isExpanded()) {
						<span>{{ labels[menuItem.name] ? labels[menuItem.name] : menuItem.name }}</span>
					}
					@if (menuItem.children?.length > 0) {
						<fa-icon class="expandIcon" [icon]="menuItem.expanded ? icons.faAngleDown : icons.faAngleRight"></fa-icon>
					}
				</div>
				@if (menuItem.expanded) {
					@for (childrenMenuItem of menuItem.children; track childrenMenuItem) {
						<a class="menu-item children" [routerLink]="childrenMenuItem.routerLink" [routerLinkActive]="'active'">
							<fa-icon [icon]="childrenMenuItem.icon"></fa-icon>
							@if (isExpanded()) {
								<span>{{ labels[childrenMenuItem.name] ? labels[childrenMenuItem.name] : childrenMenuItem.name }}</span>
							}
						</a>
					}
				}
			}
		}
	</div>
</div>
